import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  id: number;
  name: string;
  display_name: string;
  code: string;
  is_active: boolean;
}

export const useUpdateDivision = () => {
  const { authHeader } = useAuth();

  return useMutation(({ id, ...params }: Params) => {
    return axios.put(`${env.verifyServiceUrl}common/division/${id}/`, params, {
      headers: {
        Authorization: authHeader,
      },
    });
  });
};
